const AppFlowActions = {
  LOADING_COMPLETE: 'LOADING_COMPLETE',

  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_COMPLETE: 'LOGIN_COMPLETE',

  LOGOUT_REQUEST: 'LOGOUT_REQUEST',

  EXPIRED_TOKEN: 'EXPIRED_TOKEN',

  SAVE_SUPPORT_FACILITIES_COMPLETE: 'SAVE_SUPPORT_FACILITIES_COMPLETE',

  CHANGE_SELECTED_FACILITY_COMPLETE: 'CHANGE_SELECTED_FACILITY_COMPLETE',

  SAVE_EVENT_BUCKETS_COMPLETE: 'SAVE_EVENT_BUCKETS_COMPLETE',

  LOAD_PAGE_REQUEST: 'LOAD_PAGE_REQUEST',

  REPORT_REMINDER_UPDATE: 'REPORT_REMINDER_UPDATE',
  REPORT_REMINDER_COMPLETE: 'REPORT_REMINDER_COMPLETE',

  FETCH_PHYSICIANS_REQUEST: 'FETCH_PHYSICIANS_REQUEST',
  FETCH_PHYSICIANS_COMPLETE: 'FETCH_PHYSICIANS_COMPLETE',

  UPDATE_GOTO: 'UPDATE_GOTO',

  CHANGE_REGISTERED_EVENT_BUCKET_RESQUEST: 'CHANGE_REGISTERED_EVENT_BUCKET_RESQUEST',

  FETCH_NOTIFICATIONS_REQUEST: 'FETCH_NOTIFICATIONS_REQUEST',
  FETCH_NOTIFICATIONS_COMPLETE: 'FETCH_NOTIFICATIONS_COMPLETE',
  UPDATE_NOTIFICATIONS_REQUEST: 'UPDATE_NOTIFICATIONS_REQUEST',

  FETCH_SUPPORT_FACILITIES_REQUEST: 'FETCH_SUPPORT_FACILITIES_REQUEST',
  FETCH_SUPPORT_FACILITIES_COMPLETE: 'FETCH_SUPPORT_FACILITIES_COMPLETE',

  UPDATE_FETCH_REPORT_REMINDERS_STATUS_REQUEST: 'UPDATE_FETCH_REPORT_REMINDERS_STATUS_REQUEST',

  FETCH_ME_REQUEST: 'FETCH_ME_REQUEST',
  FETCH_ME_COMPLETE: 'FETCH_ME_COMPLETE',
  SET_ME_DATA: 'SET_ME_DATA',
};

export default AppFlowActions;
